module.exports = __webpack_public_path__ + "img/video-ended.36d6ce33.svg";